import React, { Component } from 'react'
import { connect } from 'react-redux'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'

import dataActions from 'actions/dataActions'

export class AddButton extends Component{
	state = { isOpen: false }
	toggleMenu = () => {
	    this.setState({
	    	isOpen: !this.state.isOpen
	    })
  	}
	render(){
		let { props } = this
		return(
			<div className="button">
				<span
					style={{
						cursor: "pointer"
					  , color: props.color || "#5ae4c3"
					}}
					onClick={()=>{props.children? this.toggleMenu(): props.act?props.act(props.object):props.ADD(props.object)}}
				>
				   <svg
						width="18px"
						height="25px"
						viewBox="0 0 24 24"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							verticalAlign: "middle"
						  , marginRight: "4px"
						  , marginTop: "-2px"
						}}
					>
						<g id="Page-1" stroke={props.color || "#5ae4c3"} strokeWidth="2" fill="none" fillRule="evenodd">
							<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke={props.color || "#5ae4c3"} strokeWidth="2">
								<path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
								<path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
								<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
							</g>
						</g>
					</svg>
					<span style={{borderBottom: "dotted 2px " +  (props.color || "#5ae4c3")}}>NEW</span>
				</span>
				{props.children &&
					<IconMenu
						iconButtonElement={<IconButton style={{padding:"0", height:"0px", width:"0px"}}></IconButton>}
						anchorOrigin={{horizontal: 'left', vertical: 'top'}}
						targetOrigin={{horizontal: 'left', vertical: 'top'}}
						open={this.state.isOpen}
						onRequestChange={this.toggleMenu}
						onItemTouchTap={(event, obj)=>{obj.props.act?obj.props.act(obj.props.object):props.ADD(obj.props.object)}}
						style={{
							verticalAlign: "middle"
						  , padding:"0"
						}}
					>
						{props.children}
					</IconMenu>
				}
			</div>
		)
	}
}
export default connect(null, dataActions)(AddButton)



// WEBPACK FOOTER //
// ./src/components/AddButton.js